import { getBaseUrl, sessionFetch } from './http';

export async function healthCheck() {
    const response = await sessionFetch(`${getBaseUrl().replace('/api', '')}/health`);
    return response.json();
  }

export const healthCheckApi = {
  healthCheck,
};

